import { MATCH_URL_RUTUBE, MATCH_URL_VKVIDEO } from "./canPlay.js";
const getEmbedSrc = (src)=>{
    let embedSrc = '';
    const vkVideoMatch = src.match(MATCH_URL_VKVIDEO);
    const rutubeMatch = src.match(MATCH_URL_RUTUBE);
    if (vkVideoMatch) embedSrc = `https://vkvideo.ru/video_ext.php?oid=${vkVideoMatch[1]}&id=${vkVideoMatch[2]}`;
    if (rutubeMatch) embedSrc = `https://rutube.ru/play/embed/${rutubeMatch[1]}/`;
    return embedSrc;
};
export { getEmbedSrc };
